export enum MeridianPortalModeType {
    WHOLESALE = 'broker',
    NON_DEL_COR = 'minicorrespondent',
    COR = 'correspondent'
}